<template>
    <div
        class="fixed bottom-2 right-2 flex items-start justify-end"
        style="z-index: 99999999"
    >
        <div class="w-full max-w-sm">
            <transition name="fade">
                <div v-if="show">
                    <div
                        class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow p-4 border border-blue-500 justify-start items-start gap-3"
                    >
                        <div
                            class="flex items-center justify-center text-blue-500"
                        >
                            <Icon icon="loader" svgClass="w-5 h-5" />
                        </div>
                        <div
                            class="flex-col justify-start items-start flex text-sm flex-grow"
                        >
                            <span class="text-blue-800 font-medium">
                                Updating your account data...
                            </span>
                            <p class="text-slate-500 font-normal">
                                Data sync in progress
                            </p>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { notify } from 'notiwind';
import Icon from '@/components/ui/icon/icon.vue';

let timerInterval;

const emit = defineEmits(['complete']);
const hasNotiwind = ref(false);
const show = ref(false);

const dataSync = () => {
    axios
        .get('/api/data/sync')
        .then((response) => {
            if (response.data.in_progress && !hasNotiwind.value) {
                show.value = true;
                startTimer();
                hasNotiwind.value = true;
                emit('complete', response.data);
            }
            if (!response.data.in_progress) {
                show.value = false;
                hasNotiwind.value = false;
                stopTimer();
            }
        })
        .catch((e) => {
            console.log(e);
            show.value = false;
            hasNotiwind.value = false;
            notify(
                {
                    group: 'error',
                    title: 'Error',
                    message: 'There was a problem with your account data sync',
                },
                5000
            );
        });
};

const startTimer = () => {
    timerInterval = setInterval(() => {
        dataSync();
    }, 2000);
};

const stopTimer = () => {
    clearInterval(timerInterval);
};

onMounted(() => {
    dataSync();
});

onBeforeUnmount(() => {
    stopTimer();
});
</script>
